<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Mark Leave Approval Matrix</v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" md="3" sm="3" class="pt-3">
                    <v-autocomplete color="#0F2027" dense placeholder="Select Leave Type" rounded required
                        v-model="leave_type" :items="leave_type_list" item-text="type" return-object label="Leave Type"
                        outlined @click="putnull()" />
                </v-col>
                <v-col cols="12" md="3" sm="3" v-if="leave_type">
                    <v-btn class="button" @click="apply()" :loading="loader">Proceed</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="mark_leave_approval_matrix != ''" class="box">
                <div class="form-check pt-4">
                    <v-btn class="button" @click="dialog_emp = true" :loading="loader">Employee Type Not Set
                        Employees</v-btn>
                    <input class="form-check-input" type="checkbox" v-model="copy_data" />
                    <label class="form-check-label ml-3 pb-2" for="flexCheckDefault">
                        <strong> Do you want to copy leave approval matrix from {{ leave_type.type }} to Other Leave
                            type?</strong>
                    </label>
                </div>
                <v-col cols="12" md="3" sm="3" class="pt-3" v-if="copy_data == true">
                    <v-autocomplete color="#0F2027" dense placeholder="Select Leave Type" multiple rounded required
                        v-model="leave_type_copy" :items="leave_type_list" item-text="type" item-value="id"
                        label="Leave Type" outlined />
                </v-col>
                <v-col cols="12" md="3" sm="3" v-if="leave_type_copy != ''">
                    <v-btn class="button" @click="copy()" :loading="loader2">Copy</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="mark_leave_approval_matrix != ''">
                <div id="my-table-id">
                    <div class="scroll">
                        <v-simple-table dense class="elevation-1 mytable" fixed-header height="500px">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Employee</th>
                                    <th v-for="(h, index) in leave_approval_heirarchy" :key="index">
                                        {{ h.name }}
                                    </th>
                                </tr>
                                <thead>
                                    <tr>
                                        <td colspan="2"></td>
                                        <td v-for="(h, index) in leave_approval_heirarchy" :key="index">
                                            <v-autocomplete class="pt-3" color="#0F2027" dense
                                                placeholder="Select Reporting Athority" rounded required
                                                v-model="h.inst" :items="mark_leave_approval_matrix" item-text="name"
                                                item-value="id" outlined />
                                            <!-- <v-checkbox dense  color="#0F2027" label="Is Same For All" @click="saveforall(h.inst,h.id)"></v-checkbox>  -->
                                            <div class="form-check" v-if="h.inst != ''">
                                                <input class="form-check-input" type="checkbox" value="h.inst" id="h.id"
                                                    @click="saveforall(h.inst, h.id)" />
                                                <label class="form-check-label ml-3 pb-2" for="flexCheckDefault">
                                                    <strong>Is Same For All</strong>
                                                </label>
                                            </div>
                                        </td>
                                    </tr>
                                </thead>
                            </thead>
                            <tbody>
                                <tr v-for="(m, index) in leave_approval_heirarchy_list" :key="m.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ m.emp.name }}</td>
                                    <td v-for="(h, index) in leave_approval_heirarchy" :key="index">
                                        <v-autocomplete class="pt-3" color="#0F2027" dense
                                            placeholder="Select Reporting Athority" rounded required
                                            v-model="m[h.level]" :items="mark_leave_approval_matrix" item-text="name"
                                            return-object outlined />
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </div>
                <v-row justify="center" dense>
                    <v-btn class="button" @click="save(leave_approval_heirarchy_list)" :loading="loader1">Save</v-btn>
                </v-row>
            </v-col>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-overlay :value="overlay1">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-dialog v-model="dialog_emp" persistent max-width="700px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                        </v-text-field> <br>
                        <v-data-table :headers="headers" :items="all_emp_list_net" class="elevation-1 mytable" dense
                            :search="search"></v-data-table>
                        <v-row justify="center" dense>
                            <v-btn class="button" @click="dialog_emp=false" :loading="loader1">Cancel</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
  import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
      data: () => ({
          loader: false,
        //   extraBreadcrumbItems: [


        //   ],
        //   breadcrumbClass: "breadcrumb-style1",
          loader1: false,
          snackbar_msg: "",
          color: "",
          snackbar: false,
          leave_type_list: [],
          leave_type: null,
          leave_approval_heirarchy_list: [],
          mark_leave_approval_matrix: [],
          leave_approval_heirarchy: [],
          copy_data: null,
          overlay: false,
          overlay1: false,
          loader2: false,
          leave_type_copy: [],
          all_emp_list_net: [],
          dialog_emp:false,
          search:null,
          headers: [
                {
                    text: "Employee",
                    align: "left",
                    sortable: false,
                    value: "name",
                },
              ]
      }),
      methods: {
          putnull() {
              (this.leave_approval_heirarchy_list = []), (this.mark_leave_approval_matrix = []), (this.leave_approval_heirarchy = []);
          },
          copy() {
              this.loader2 = true;
              const data = {
                  leave_type: this.leave_type.id,
                  leave_type_copy: this.leave_type_copy,
              };
              axios
                  .post("/LeaveManagement/copyLeaveApprovalMatrix", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Leave Approval Matrix Copied Successfully...");
                          this.apply();
                          this.loader2 = false;
                      }
                  })
                  .catch((error) => {
                      this.loader2 = false;
                      this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                  })
                  .finally(() => {
                      this.loader2 = false;
                  });
          },
          saveforall(item, item2) {
              this.overlay = true;
              const data = {
                  inst: item,
                  level: item2,
                  leave_type: this.leave_type.id,
              };
              axios
                  .post("/LeaveManagement/saveLeaveApprovalMatrixForAll", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Leave Approval Matrix Save Successfully...");
                          this.apply();
                          this.overlay = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                      this.overlay = false;
                  })
                  .finally(() => {
                      this.overlay = false;
                  });
          },
          save(leave_approval_heirarchy_list) {
              this.loader1 = true;
              const data = {
                  leave_approval_heirarchy_list: leave_approval_heirarchy_list,
                  leave_type: this.leave_type.id,
              };
              axios
                  .post("/LeaveManagement/saveLeaveApprovalMatrix", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Leave Approval Matrix Save Successfully...");
                          this.loader1 = false;
                          this.apply();
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                      this.loader1 = false;
                  })
                  .finally(() => {
                      this.loader = false;
                  });
          },
          apply() {
              this.overlay1 = true;
              const data = {
                  leave_type: this.leave_type.id,
              };
              axios
                  .post("/LeaveManagement/getLeaveTypeHierarchy", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.leave_approval_heirarchy_list = res.data.leave_approval_heirarchy_list;
                          this.mark_leave_approval_matrix = res.data.mark_leave_approval_matrix;
                          this.leave_approval_heirarchy = res.data.leave_approval_heirarchy;
                          this.all_emp_list_net = res.data.all_emp_list_net;
                          this.loader = false;
                      } else if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.smsg);
                          this.overlay1 = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                      this.overlay1 = false;
                  })
                  .finally(() => {
                      this.overlay1 = false;
                  });
          },
          onLoad() {
              axios
                  .post("/LeaveManagement/getLeaveType")
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.leave_type_list = res.data.leave_type_list;
                      } else {
                          this.showSnackbar("#b71c1c", "Wrong information");
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                  })
                  .finally(() => {
                      // 'use strict';
                  });
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
      },
      mounted() {
          this.onLoad();
      },
  };
</script>
<style scoped>
  input[type="text"] {
      width: 100%;
      display: inline-block;
      border: 1px solid black;
      border-radius: 4px;
      box-sizing: border-box;
  }
  .select {
      width: 100%;
      display: inline-block;
      border: 1px solid black;
      border-radius: 4px;
      box-sizing: border-box;
  }
  input[type="date"] {
      width: 50%;
      display: inline-block;
      padding: 0.3rem;
      border: 1px solid gray;
      border-radius: 30px;
      box-sizing: border-box;
      padding-top: none !important;
      margin-top: none !important;
  }
  .table-head-background {
      background-color: #fcc96f;
      color: #fff;
      font-weight: 700;
  }
  .tc-title {
      background-image: linear-gradient(-90deg, #fcc96f, #fcb63c);
      color: #fff;
      font-weight: 700;
      margin: 0px !important;
      padding: 0px !important;
  }
  .text-left {
      font-size: 14px;
      font-weight: bold;
  }
  .text {
      color: blue;
      font-weight: 600;
      font-size: 14px;
  }

  tr,
  td,
  th {
      border: 1px solid #ccc;
      text-align: center;
      font-size: small;
  }
  tr,
  tbody {
      border-bottom: 1px solid #ccc;
      border: 1px solid #ccc;
      font-size: small;
  }
  td {
      margin: 0.3rem !important;
      padding: 0.4rem !important;
      font-size: small;
  }
  @media (min-width: 320px) {
      td,
      th {
          display: table-cell !important;
          font-size: small;
      }
      td + td,
      th + th {
          width: auto;
          font-size: small;
      }
  }
  v-simple-table {
      white-space: nowrap !important;
      text-align: center;
      font-size: small;
  }
</style>
